// "Add another" is transient pointer intent, not selection: it lives here so the toolbar (UI1's
// inspectToolbarSlot) and the layer (canvasOverlaySlot) share it without a second selection
// store. Keyed by INS session; forgotten when Inspect turns off.
import { useCallback, useSyncExternalStore } from 'react';

const addMode = new Map<string, boolean>();
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((fn) => fn());

export function setAddMode(sessionId: string, value: boolean): void {
  if ((addMode.get(sessionId) ?? false) === value) return;
  if (value) addMode.set(sessionId, true);
  else addMode.delete(sessionId);
  emit();
}

export function useAddMode(sessionId: string): [boolean, (value: boolean) => void] {
  const value = useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => addMode.get(sessionId) ?? false,
    () => false,
  );
  const set = useCallback((next: boolean) => setAddMode(sessionId, next), [sessionId]);
  return [value, set];
}
